module.exports = __webpack_public_path__ + "img/error.6ce2f1b5.png";